import { configureStore, combineReducers } from "@reduxjs/toolkit";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import logger from "redux-logger";

import createSagaMiddleware from "redux-saga";
import { createRouterMiddleware, createRouterReducer } from "@lagunovsky/redux-react-router";
import { history } from "../../config/history";

/* Reducers */
import fileReducer from "../reducers/file";
import processingReducer from "../reducers/processing";
import sessionReducer from "../reducers/session";
import projectReducer from "../reducers/project";
import contextReducer from "../reducers/context";
import libraryFiltersReducer from "@/features/library/stores/filtersSlice";
import contextSelectionFiltersReducer from "@/features/study/stores/filtersSlice";

// base API slice
import { api } from "./apiSlice";

// All Sagas
import sagas from "../sagas/index";

// combineReducer allows you to call seperate reducers for each state
const rootReducer = combineReducers({
  [api.reducerPath]: api.reducer,
  file: fileReducer,
  processing: processingReducer,
  session: sessionReducer,
  project: projectReducer, // remove getStudy from persist due to intial state of study bug
  context: contextReducer,
  router: createRouterReducer(history),
  libraryFilters: libraryFiltersReducer,
  contextSelectionFilters: contextSelectionFiltersReducer,
});

const persistConfig = {
  key: "df-primary-2",
  version: 1,
  storage,
  blacklist: ["app", "api", "project", "libraryFilters", "contextSelectionFilters", "router"],
};

/* Middleware */
const routerMiddleware = createRouterMiddleware(history);
const sagaMiddleware = createSagaMiddleware();
const middlewares = [routerMiddleware, sagaMiddleware, api.middleware];

/* Reducer */
const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  // Can create a root reducer separately and pass that in
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) => {
    const middleware = getDefaultMiddleware({
      // Customize the built-in serializability dev check
      /* serializableCheck: {
        ignoredActions: [ FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER ],
      }, */
      serializableCheck: false,
    }).concat(middlewares);

    // Conditionally add another middleware in dev
    if (process.env.NODE_ENV !== "production") {
      middleware.push(logger);
    }

    return middleware;
  },
  // Turn off devtools in prod, or pass options in dev
  devTools: process.env.NODE_ENV !== "production",
});

// Run Sagas
sagaMiddleware.run(sagas);

export const persistor = persistStore(store);
